import { cn } from "@/lib/utils";
import type { SectionNavigationItemProps } from "./SectionNavigationDialog.types";
import SectionNavigationSubItem from "./SectionNavigationSubItem";

const SectionNavigationItem = ({
  section,
  isActive,
  activeSection,
  onNavigate,
}: SectionNavigationItemProps) => {
  return (
    <div>
      {/* Main Section - No tree outline */}
      {section.label && (
        <button
          type="button"
          onClick={() => onNavigate(section.id)}
          className={cn(
            "w-full text-left hover:text-violet-800 font-medium px-3 py-1 text-sm transition-colors rounded-sm",
            "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-violet-500 focus-visible:ring-offset-1",
            isActive ? "text-violet-900" : "text-gray-900",
          )}
        >
          {section.label}
        </button>
      )}

      {/* Subsections with tree outline */}
      {section.subsections && section.subsections.length > 0 && (
        <div className="ml-4 mt-1 space-y-0 relative border-l border-gray-300">
          {section.subsections.map((subsection) => (
            <SectionNavigationSubItem
              key={subsection.id}
              subsection={subsection}
              isActive={activeSection === subsection.id}
              activeSection={activeSection}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SectionNavigationItem;
